// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host .container {
  width: 400px;
}
:host .item-block {
  display: block;
}
:host .item-block mat-select, :host .item-block input, :host .item-block span {
  width: calc(100% - 5px);
}`, "",{"version":3,"sources":["webpack://./src/app/device/tag-property/tag-property-edit-opcua/tag-property-edit-opcua.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/device/tag-property/tag-property-edit-opcua/tag-property-edit-opcua.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;ACCJ;ADCI;EACI,YAAA;ACCR;ADEI;EACI,cAAA;ACAR;ADCQ;EACI,uBAAA;ACCZ","sourcesContent":[":host {\n    display: block;\n\n    .container {\n        width: 400px;\n    }\n\n    .item-block {\n        display: block;\n        mat-select, input, span {\n            width:calc(100% - 5px);\n        }\n    }\n}",":host {\n  display: block;\n}\n:host .container {\n  width: 400px;\n}\n:host .item-block {\n  display: block;\n}\n:host .item-block mat-select, :host .item-block input, :host .item-block span {\n  width: calc(100% - 5px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
